var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 54,
    viewBox: "0 0 47 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.875V10.125C0 9.22989 0.353698 8.37145 0.983284 7.73851C1.61287 7.10558 2.46677 6.75 3.35714 6.75H6.71429V3.375C6.71429 2.47989 7.06798 1.62145 7.69757 0.988515C8.32716 0.355579 9.18106 0 10.0714 0C10.9618 0 11.8157 0.355579 12.4453 0.988515C13.0749 1.62145 13.4286 2.47989 13.4286 3.375V6.75H33.5714V3.375C33.5714 2.47989 33.9251 1.62145 34.5547 0.988515C35.1843 0.355579 36.0382 0 36.9286 0C37.8189 0 38.6728 0.355579 39.3024 0.988515C39.932 1.62145 40.2857 2.47989 40.2857 3.375V6.75H43.6429C44.5332 6.75 45.3871 7.10558 46.0167 7.73851C46.6463 8.37145 47 9.22989 47 10.125V16.875H0ZM0 20.25V50.625C0 51.5201 0.353698 52.3785 0.983284 53.0115C1.61287 53.6444 2.46677 54 3.35714 54H43.6429C44.5332 54 45.3871 53.6444 46.0167 53.0115C46.6463 52.3785 47 51.5201 47 50.625V20.25H0Z",
    fill: "url(#paint0_linear_12_269)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12_269",
    x1: 22.9973,
    y1: 41.58,
    x2: -16.8912,
    y2: 35.1954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCBD49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.2d427bf3c2dfcfaa245ec78c34ef21e4.svg";
export { ForwardRef as ReactComponent };